import {OktaUser, User} from './user';
import {GeoInfo} from './geo-info';

export class PageAccessInfo {
  constructor(public user: User,
              public oktaInfo: OktaUser,
              public geoInfo: GeoInfo,
              public isAuthorized: boolean = false) {
    this.user = user;
    this.oktaInfo = oktaInfo;
    this.geoInfo = geoInfo;
    this.isAuthorized = isAuthorized;
  }
}
